import { jsx as c } from "react/jsx-runtime";
import * as f from "react";
import { forwardRef as T } from "react";
import { c as g } from "./index-DLeNytVF.js";
import { c as D } from "./index-UFb2E87s.js";
import { c as N, R as V, I as k } from "./index-Dk8WN7YM.js";
import { P as G } from "./index-L6dgm95g.js";
import { P as v } from "./index-BrTLHETv.js";
import { u as L } from "./index-ByaXH_ih.js";
import { u as j } from "./index-DYfkNB0n.js";
import { u as K } from "./index-umR1UobZ.js";
import { $ as y } from "./utils-CTvPli9r.js";
var p = "Tabs", [B, re] = D(p, [
  N
]), C = N(), [q, h] = B(p), I = f.forwardRef(
  (e, t) => {
    const {
      __scopeTabs: a,
      value: o,
      onValueChange: i,
      defaultValue: d,
      orientation: n = "horizontal",
      dir: l,
      activationMode: m = "automatic",
      ...b
    } = e, s = L(l), [r, u] = j({
      prop: o,
      onChange: i,
      defaultProp: d ?? "",
      caller: p
    });
    return /* @__PURE__ */ c(
      q,
      {
        scope: a,
        baseId: K(),
        value: r,
        onValueChange: u,
        orientation: n,
        dir: s,
        activationMode: m,
        children: /* @__PURE__ */ c(
          v.div,
          {
            dir: s,
            "data-orientation": n,
            ...b,
            ref: t
          }
        )
      }
    );
  }
);
I.displayName = p;
var x = "TabsList", R = f.forwardRef(
  (e, t) => {
    const { __scopeTabs: a, loop: o = !0, ...i } = e, d = h(x, a), n = C(a);
    return /* @__PURE__ */ c(
      V,
      {
        asChild: !0,
        ...n,
        orientation: d.orientation,
        dir: d.dir,
        loop: o,
        children: /* @__PURE__ */ c(
          v.div,
          {
            role: "tablist",
            "aria-orientation": d.orientation,
            ...i,
            ref: t
          }
        )
      }
    );
  }
);
R.displayName = x;
var _ = "TabsTrigger", w = f.forwardRef(
  (e, t) => {
    const { __scopeTabs: a, value: o, disabled: i = !1, ...d } = e, n = h(_, a), l = C(a), m = S(n.baseId, o), b = M(n.baseId, o), s = o === n.value;
    return /* @__PURE__ */ c(
      k,
      {
        asChild: !0,
        ...l,
        focusable: !i,
        active: s,
        children: /* @__PURE__ */ c(
          v.button,
          {
            type: "button",
            role: "tab",
            "aria-selected": s,
            "aria-controls": b,
            "data-state": s ? "active" : "inactive",
            "data-disabled": i ? "" : void 0,
            disabled: i,
            id: m,
            ...d,
            ref: t,
            onMouseDown: g(e.onMouseDown, (r) => {
              !i && r.button === 0 && r.ctrlKey === !1 ? n.onValueChange(o) : r.preventDefault();
            }),
            onKeyDown: g(e.onKeyDown, (r) => {
              [" ", "Enter"].includes(r.key) && n.onValueChange(o);
            }),
            onFocus: g(e.onFocus, () => {
              const r = n.activationMode !== "manual";
              !s && !i && r && n.onValueChange(o);
            })
          }
        )
      }
    );
  }
);
w.displayName = _;
var A = "TabsContent", P = f.forwardRef(
  (e, t) => {
    const { __scopeTabs: a, value: o, forceMount: i, children: d, ...n } = e, l = h(A, a), m = S(l.baseId, o), b = M(l.baseId, o), s = o === l.value, r = f.useRef(s);
    return f.useEffect(() => {
      const u = requestAnimationFrame(() => r.current = !1);
      return () => cancelAnimationFrame(u);
    }, []), /* @__PURE__ */ c(G, { present: i || s, children: ({ present: u }) => /* @__PURE__ */ c(
      v.div,
      {
        "data-state": s ? "active" : "inactive",
        "data-orientation": l.orientation,
        role: "tabpanel",
        "aria-labelledby": m,
        hidden: !u,
        id: b,
        tabIndex: 0,
        ...n,
        ref: t,
        style: {
          ...e.style,
          animationDuration: r.current ? "0s" : void 0
        },
        children: u && d
      }
    ) });
  }
);
P.displayName = A;
function S(e, t) {
  return `${e}-trigger-${t}`;
}
function M(e, t) {
  return `${e}-content-${t}`;
}
var z = I, $ = R, E = w, F = P;
const ie = z, H = T(({ className: e, ...t }, a) => /* @__PURE__ */ c(
  $,
  {
    ref: a,
    className: y(
      "inline-flex h-9 items-center justify-center rounded-lg bg-muted p-1 text-muted-foreground",
      e
    ),
    ...t
  }
));
H.displayName = $.displayName;
const O = T(({ className: e, ...t }, a) => /* @__PURE__ */ c(
  E,
  {
    ref: a,
    className: y(
      "inline-flex items-center justify-center whitespace-nowrap rounded-md px-3 py-1 text-sm font-medium ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[state=active]:bg-background data-[state=active]:text-foreground data-[state=active]:shadow",
      e
    ),
    ...t
  }
));
O.displayName = E.displayName;
const J = T(({ className: e, ...t }, a) => /* @__PURE__ */ c(
  F,
  {
    ref: a,
    className: y(
      "mt-2 ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
      e
    ),
    ...t
  }
));
J.displayName = F.displayName;
export {
  ie as Tabs,
  J as TabsContent,
  H as TabsList,
  O as TabsTrigger
};
//# sourceMappingURL=tabs.js.map
